(function (app) {
    //Tested that it works when used with multiple different filters. Add this filter at the end to avoid conflicts ({{property.value | someFilter | addDash}})
    function addDash() {
        return function (input) {
           return input ? input : '-';
        };
    }

    addDash.$inject = [];
    app.filter("addDash", addDash);

})(window.app); //jshint ignore:line